module.exports = __webpack_public_path__ + "img/2024052214500702732d.7613b9bc.jpg";